// src/components/ChartModal.jsx
import React from 'react';

const ChartModal = ({ isOpen, metric, onClose }) => {
  if (!isOpen || !metric) return null;

  return (
    <div
      className={`modal-backdrop ${isOpen ? 'modal-open' : 'modal-closed'}`}
      onClick={onClose}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header: title + X */}
        <div className="modal-header">
          <h2>{metric.title}</h2>
          <button
            className="modal-close"
            onClick={onClose}
            aria-label="Close chart"
          >
            ×
          </button>
        </div>

        {/* FRED chart only – no extra description text */}
        <div className="modal-chart">
          {metric.embedUrl && (
            <iframe
              className="fred-iframe"
              src={metric.embedUrl}
              title={metric.title}
              loading="lazy"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChartModal;
